import React from 'react';
import Navbar from '../components/Navbar';

/* TO DO:
 * Create table of leading coders (arbiters and standards)
 */

const LeaderBoardPage = () => {
  return (
    <div className="LeaderBoardPage">
        <Navbar/>
        LeaderBoardPage
    </div>
  );
};

export default LeaderBoardPage;